import { useLocalizeOffsetValues } from '@mews-commander/ui';
import { DurationService, useLocalizeText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';

const settlementRuleTriggerTextKeyMap = {
    Confirmation: TextKey.PaymentPolicyTriggerConfirmation,
    StartDate: TextKey.PaymentPolicyTriggerArrivalDate,
    Start: TextKey.PaymentPolicyTriggerCheckInTime,
    EndDate: TextKey.PaymentPolicyTriggerDepartureDate,
    End: TextKey.PaymentPolicyTriggerCheckOutTime,
};

const settlementRuleTriggerWithOffsetAfterTextKeyMap = {
    Confirmation: TextKey.PaymentPolicyTriggerConfirmationWithOffsetAfter,
    StartDate: TextKey.PaymentPolicyTriggerArrivalDateWithOffsetAfter,
    Start: TextKey.PaymentPolicyTriggerCheckInTimetWithOffsetAfter,
    EndDate: TextKey.PaymentPolicyTriggerDepartureDateWithOffsetAfter,
    End: TextKey.PaymentPolicyTriggerCheckOutTimeWithOffsetAfter,
};

const settlementRuleTriggerWithOffsetBeforeTextKeyMap = {
    Confirmation: TextKey.PaymentPolicyTriggerConfirmationWithOffsetBefore,
    StartDate: TextKey.PaymentPolicyTriggerArrivalDateWithOffsetBefore,
    Start: TextKey.PaymentPolicyTriggerCheckInTimetWithOffsetBefore,
    EndDate: TextKey.PaymentPolicyTriggerDepartureDateWithOffsetBefore,
    End: TextKey.PaymentPolicyTriggerCheckOutTimeWithOffsetBefore,
};

export interface SettlementRuleTimingProps {
    trigger: 'Confirmation' | 'StartDate' | 'Start' | 'EndDate' | 'End';
    offset: string;
}

export const useSettlementRuleTimingGetter = () => {
    const localizeText = useLocalizeText();
    const localizeOffsetValues = useLocalizeOffsetValues();

    return ({ trigger, offset }: SettlementRuleTimingProps) => {
        const duration = DurationService.parse(offset);

        if (DurationService.isZero(duration)) {
            return localizeText({ textKey: settlementRuleTriggerTextKeyMap[trigger] });
        }

        const substitutes = { offset: localizeOffsetValues(duration) };

        if (DurationService.isNegative(duration)) {
            return localizeText({
                textKey: settlementRuleTriggerWithOffsetBeforeTextKeyMap[trigger],
                substitutes,
            });
        }

        return localizeText({
            textKey: settlementRuleTriggerWithOffsetAfterTextKeyMap[trigger],
            substitutes,
        });
    };
};

export const SettlementRuleTiming = (props: SettlementRuleTimingProps) => {
    const getSettlementRuleTiming = useSettlementRuleTimingGetter();
    return <>{getSettlementRuleTiming(props)}</>;
};
